import React from 'react';
import PropTypes from 'prop-types';
import { resolveContentUrl } from '../../../../modules/assets';
import EmbedVideo from '../EmbedVideo';
import MediaGalleryImage from '../../../../modules/react/components/stateful/MediaGalleryImage';
import styles from './ImageCarousel.scss';

const propTypes = {
  asset: PropTypes.shape({
    file: PropTypes.string,
    staticImg: PropTypes.bool,
    alt: PropTypes.string.isRequired,
    medium: PropTypes.shape(),
  }).isRequired,
  onClick: PropTypes.func,
  lightbox: PropTypes.bool,
  mediaClassnames: PropTypes.string,
};
const defaultProps = {
  onClick: undefined,
  lightbox: false,
  mediaClassnames: undefined,
};

const ImageCarouselAsset = ({
  asset,
  onClick,
  lightbox,
  mediaClassnames,
}) => {
  if (asset.videoEmbedCode) {
    const { videoEmbedCode } = asset;

    const videoElement = (
      <EmbedVideo
        title="embedded content"
        src={videoEmbedCode}
        style={{ width: '100%' }}
      />
    );

    return lightbox ? (
      <div className={styles.lightboxVideoItem}>
        {videoElement}
      </div>
    ) : videoElement;
  }


  const { alt, file } = asset;
  return (
    <button
      onClick={onClick}
      type="button"
      style={{ all: 'unset', cursor: 'pointer', width: '100%' }}
    >
      {asset.medium && !asset.staticImg ? (
        <MediaGalleryImage
          key={(asset.medium && asset.medium.id) || asset.file}
          medium={asset.medium}
          legacyImage={asset}
          className={mediaClassnames}
          width={asset.medium.sourceWidth}
          height={asset.medium.sourceHeight}
          {...asset}
        />
      ) : (
        <img
          alt={alt}
          src={resolveContentUrl(file)}
          loading="eager"
          className={mediaClassnames}
        />
      )}
    </button>
  );
};

ImageCarouselAsset.propTypes = propTypes;
ImageCarouselAsset.defaultProps = defaultProps;

export default ImageCarouselAsset;
